const sentinel = document.querySelector("#ProductBuy");
const bar = document.querySelector("[data-buy-bar]");
if (sentinel && bar && "IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      const pastBuy = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !pastBuy;
    },
    { threshold: 0, rootMargin: "0px" }
  );
  observer.observe(sentinel);
}

const seg = document.querySelector("[data-plan-seg]");
if (seg) {
  const buttons = [...seg.querySelectorAll("[data-plan]")];
  const sellingPlan = document.querySelector("[data-selling-plan]");
  const usps = document.querySelector("[data-plan-usps]");
  const price = document.querySelector("[data-plan-price]");
  const priceValue = document.querySelector("[data-plan-price-value]");
  const submits = [...document.querySelectorAll("[data-plan-submit]")];

  function setPlan(plan) {
    const monthly = plan === "month";
    buttons.forEach((button) => {
      button.setAttribute("aria-pressed", button.dataset.plan === plan ? "true" : "false");
    });
    if (sellingPlan) sellingPlan.disabled = !monthly;
    if (usps) usps.hidden = !monthly;
    if (price && priceValue) {
      priceValue.textContent = monthly ? price.dataset.priceMonth : price.dataset.priceOnce;
    }
    const compare = price?.querySelector("[data-plan-price-compare]");
    const save = price?.querySelector("[data-plan-save]");
    if (compare) compare.hidden = !monthly;
    if (save) save.hidden = !monthly;
    submits.forEach((submit) => {
      const label = monthly ? submit.dataset.labelMonth : submit.dataset.labelOnce;
      if (!label) return;
      if (submit.tagName === "INPUT") submit.value = label;
      else submit.textContent = label;
    });
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.dataset.planHref) {
        window.location.assign(button.dataset.planHref);
        return;
      }
      setPlan(button.dataset.plan);
    });
  });
}
